import React from "react";

import { Code } from "@packages/ds";
import { useIntl } from "react-intl";

import { Link } from "ds/Button";

import { Description, LinkWrapper } from "../style";

type CLICommandProps = {
  command: string;
};

const CLICommand = ({ command }: CLICommandProps) => {
  const formatMessage = useIntl().formatMessage;
  return (
    <div>
      <Description>
        {formatMessage({ id: "cli.clone.description" })}
      </Description>
      <Code.Block id="environment-cli-cmd" isCopyable singleLine={true}>
        {command}
      </Code.Block>

      <LinkWrapper>
        <Link href={formatMessage({ id: "links.CLI_repository" })}>
          {formatMessage({ id: "cli.install" })}
        </Link>
      </LinkWrapper>
    </div>
  );
};

export default CLICommand;
